import { ProgressAccordionStepProps, AccordionStep } from '../shared-components/AccordionStep';
import { HubIntroduction, SimplifiedUserRole } from '@platform/client/schemas';
import { formatDateStr } from '../../dashboard/my-projects/utils';

export const Introduction = ({
  status,
  userType,
  introduction,
}: ProgressAccordionStepProps & { introduction: HubIntroduction }) => {
  const userSent =
    (introduction.initiationType === 'Experteer' && userType === SimplifiedUserRole.PROFESSIONAL) ||
    (introduction.initiationType === 'Organization' &&
      userType === SimplifiedUserRole.REPRESENTATIVE);
  const introDate = formatDateStr(introduction.sentDate);
  const acceptedDate = formatDateStr(introduction.acceptedDate);
  return (
    <AccordionStep title='Introduction' status={status}>
      <p>
        <span className='font-semibold'>{userSent ? 'Sent' : 'Received'}: </span>
        {introDate}
      </p>
      <p>
        <span className='font-semibold'>Accepted: </span>
        {acceptedDate}
      </p>
      <div className='flex flex-col gap-2'>
        <p className='font-semibold'>Message:</p>
        <p>{introduction.message}</p>
      </div>
    </AccordionStep>
  );
};
